"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-mjf-multi-jet-fusion";

const COLS = [
	{ key: "Name", labelKey: "materialPerformanceColName" },
	{ key: "Description", labelKey: "materialPerformanceColDescription" },
	{ key: "Hardness", labelKey: "materialPerformanceColHardness" },
	{ key: "Elongation", labelKey: "materialPerformanceColElongation" },
	{ key: "Impact", labelKey: "materialPerformanceColImpact" },
] as const;

const ROWS = Array.from({ length: 5 }, (_, i) => i + 1);

export default function MjfMaterialPerformance() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-center text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("materialPerformanceTitle")}
				</h2>

				{/* Desktop table */}
				<div className="hidden overflow-x-auto md:block">
					<table className="w-full border-collapse text-sm text-black">
						<colgroup>
							<col className="w-[14%]" />
							<col className="w-[38%]" />
							<col className="w-[12%]" />
							<col className="w-[16%]" />
							<col className="w-[20%]" />
						</colgroup>
						<thead>
							<tr>
								{COLS.map((col) => (
									<th
										key={col.key}
										className="bg-[#64a525] px-5 py-4 text-left text-sm font-bold text-white lg:text-base"
									>
										{t(col.labelKey)}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{ROWS.map((n, rowIdx) => (
								<tr key={n} className="bg-[#f6ffde]">
									<td className="border-b border-[#c6c7c3] px-5 py-5 align-middle font-bold">
										{t(`materialPerformanceRow${n}Name` as any)}
									</td>
									<td className="border-b border-[#c6c7c3] px-5 py-5 align-middle leading-relaxed">
										{t(`materialPerformanceRow${n}Desc` as any)}
									</td>
									<td className="border-b border-[#c6c7c3] px-5 py-5 align-middle">
										{t(`materialPerformanceRow${n}Hardness` as any)}
									</td>
									<td className="border-b border-[#c6c7c3] px-5 py-5 align-middle">
										{t(`materialPerformanceRow${n}Elongation` as any)}
									</td>
									<td className="border-b border-[#c6c7c3] px-5 py-5 align-middle">
										{t(`materialPerformanceRow${n}Impact` as any)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				{/* Mobile cards */}
				<div className="flex flex-col gap-4 md:hidden">
					{ROWS.map((n) => (
						<div key={n} className="overflow-hidden rounded-xl border border-gray-200 bg-white">
							<div className="bg-[#64a525] px-4 py-3">
								<h4 className="text-sm font-bold text-white sm:text-base">
									{t(`materialPerformanceRow${n}Name` as any)}
								</h4>
							</div>
							<div className="px-4 py-3">
								<p className="mb-3 text-sm leading-relaxed text-black">
									{t(`materialPerformanceRow${n}Desc` as any)}
								</p>
								<div className="grid grid-cols-3 gap-px bg-gray-100">
									<div className="bg-white px-2 py-2">
										<p className="mb-1 text-xs font-semibold text-gray-500">
											{t("materialPerformanceColHardness")}
										</p>
										<p className="text-sm text-black">{t(`materialPerformanceRow${n}Hardness` as any)}</p>
									</div>
									<div className="bg-white px-2 py-2">
										<p className="mb-1 text-xs font-semibold text-gray-500">
											{t("materialPerformanceColElongation")}
										</p>
										<p className="text-sm text-black">{t(`materialPerformanceRow${n}Elongation` as any)}</p>
									</div>
									<div className="bg-white px-2 py-2">
										<p className="mb-1 text-xs font-semibold text-gray-500">
											{t("materialPerformanceColImpact")}
										</p>
										<p className="text-sm text-black">{t(`materialPerformanceRow${n}Impact` as any)}</p>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>

				<p className="mt-5 text-sm leading-relaxed text-black sm:mt-6 md:text-base">
					<span className="font-bold">{t("materialPerformanceNoteLabel")}</span>
					{t("materialPerformanceNoteText")}
				</p>
			</div>
		</section>
	);
}
